module.exports = __webpack_public_path__ + "static/media/pickup_inactive.c27b2123.svg";